var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: {
        "menu-button--container": true,
        open: _vm.open,
      },
      on: {
        click: function ($event) {
          _vm.open = true
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "menu-button--icon-wrapper" },
        [_c("IconCompass", { staticClass: "menu-button--icon" })],
        1
      ),
      _vm._v(" "),
      _c(
        "VDialog",
        {
          attrs: { "content-class": "menu--dialog", width: "auto" },
          model: {
            value: _vm.open,
            callback: function ($$v) {
              _vm.open = $$v
            },
            expression: "open",
          },
        },
        [
          _vm.open
            ? _c("NavigationMenu", {
                on: {
                  "modal-close": function ($event) {
                    _vm.open = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }